module.exports = __webpack_public_path__ + "img/graphic-1.40f7572f.svg";